import React from 'react';
import { TextField } from '@mui/material';
import { InvoiceRecord } from '../../types';

interface CreditNoteSectionProps {
  formData: Partial<InvoiceRecord>;
  onChange: (field: keyof InvoiceRecord, value: string) => void;
  disabled: boolean;
}

export const CreditNoteSection: React.FC<CreditNoteSectionProps> = ({
  formData,
  onChange,
  disabled
}) => {
  return (
    <>
      {/* Section Header */}
      <div className="border-t border-orange-200 pt-4 mt-4">
        <h4 className="text-sm font-medium text-orange-800 mb-4">Credit Note Information</h4>
      </div>

      {/* Claim Reference */}
      <TextField
        label="Claim Reference"
        variant="outlined"
        size="small"
        value={formData.claim || ''}
        onChange={(e) => onChange('claim', e.target.value)}
        disabled={disabled}
        sx={{ width: '100%' }}
        placeholder="Enter claim reference"
      />

      {/* Credit Note Number */}
      <TextField
        label="Credit Note Number"
        variant="outlined"
        size="small"
        value={formData.cn || ''}
        onChange={(e) => onChange('cn', e.target.value)}
        disabled={disabled}
        sx={{ width: '100%' }}
        placeholder="Enter credit note number"
      />

      {/* Credit Amount */}
      <TextField
        label="Credit Amount"
        type="number"
        inputProps={{ step: '0.01' }}
        variant="outlined"
        size="small"
        value={formData.credit_amount || ''}
        onChange={(e) => onChange('credit_amount', e.target.value)}
        disabled={disabled}
        sx={{ width: '100%' }}
        placeholder="0.00"
      />
    </>
  );
};
